$(document).ready(function() {

    // Routenplaner
    var googleDirURL = "https://www.google.at/maps/dir/";
    $(document).on("keydown", ".ttgAnreiseInput", function(e) {
        if (e.which == 13) {
            routingURL1 = googleDirURL + $(this).val() + "/" + $(this).attr("data-lat") + "," + $(this).attr("data-lon");
            window.open(routingURL1, "_blank");
        }
    });
    $(document).on("click", ".ttgGoogleDirBtn", function() {
        var inputObj = $(this).prev();
        if (inputObj.val().length > 2) {
            routingURL2 = googleDirURL + inputObj.val() + "/" + inputObj.attr("data-lat") + "," + inputObj.attr("data-lon");
            window.open(routingURL2, "_blank");
        }
    });

    // Static Map Image auf der Detailseite soll klickbar sein und die Modal-Map öffnen
    $(document).on("click", ".ttgStaticMapImage", function() {
        $("#ttgDetailKarteBtn").trigger("click");
    });

});

/* static map laden, wenn alles inkl. Grafiken geladen ist. */
$(window).load(function() {
    //alert('alles geladen');
    if ($("#ttgStaticPrintMapImage").length > 0) {
        var staticImageUrl = '//static.ecmaps.de/' + document.getElementById('ttgStaticPrintMapImage').getAttribute('data-staticmapsUrl');
        document.getElementById('ttgStaticPrintMapImage').setAttribute('src', staticImageUrl);
        //alert(staticImageUrl);
    }

    if ($('.ttgRenderMapForTabKarte').length) {
        $('.ttgRenderMapForTabKarte').children().appendTo('.ttgListKarte');
        $('.ttgRenderMapForTabKarte').remove();
    }

    if ($('.ttgDetailRenderMapForTab').length) {
        $('.ttgDetailRenderMapForTab').children().appendTo('#ttgTabDetailKarte');
        $('.ttgDetailRenderMapForTab').remove();
    }
});
